"use client"
import { motion } from "framer-motion"

export default function MoreAbout() {
    const words = [
        "At",
        "Lymoun",
        "logo",
        ", We",
        "don't",
        "build",
        "apps.",
        "We",
        "build",
        "experience"
    ]

    return (
        <>
            <section id="about" className=" lg:my-15 p-5 lg:p-0 relative overflow-hidden">
                <div className="grid lg:grid-cols-2 items-center relative z-10">
                    <div className="col-span-1 xl:py-26 lg:pl-28 max-w-3xl mx-auto ">
                        <h2 className="text-3xl lg:text-6xl font-medium font-brand text-foreground mb-3 flex flex-wrap items-center">
                            {words.map((word, idx) =>
                                word === "logo" ? (
                                    <motion.span
                                        key={idx}
                                        className="inline-block w-12 h-12 relative mx-2"
                                        initial={{ opacity: 0 }}
                                        whileInView={{ opacity: 1 }}
                                        viewport={{ once: true }}
                                        transition={{ delay: idx * 0.2, duration: 0.6 }}
                                    >
                                        <img
                                            src="/svg/logo.svg"
                                            className="absolute h-12 w-12 blur-md opacity-60 animate-spin [animation-duration:4s]"
                                        />
                                        <img
                                            src="/svg/logo.svg"
                                            className="absolute h-12 w-12 animate-spin [animation-duration:4s]"
                                        />
                                    </motion.span>
                                ) : (
                                    <motion.span
                                        key={idx}
                                        className="mx-2 inline-block"
                                        initial={{ opacity: 0, x: -15, filter: "blur(10px)" }}
                                        whileInView={{ opacity: 1, x: 0, filter: "blur(0px)" }}
                                        viewport={{ once: true }}
                                        transition={{ delay: idx * 0.2, duration: 0.5 }}
                                    >
                                        {word}
                                    </motion.span>
                                )
                            )}
                        </h2>
                    </div>
                    <div className="hidden lg:block h-full">
                        <div className="relative w-full h-full hidden md:block">
                            <video src="/videos/9.mp4" autoPlay loop muted playsInline className="object-cover h-full w-full absolute opacity-60" style={{ display: 'block', mixBlendMode: 'screen' }} />
                            <div className="absolute h-full w-full bg-linear-to-r from-background" />
                            <div className="absolute h-full w-full bg-linear-to-b from-background via-transparent to-background" />

                        </div>
                    </div>
                </div>
            </section>
            <div className="pb-20" />
        </>
    )
}